import React from "react";
// Common Component
import DatePicker from "src/Components/DatePicker";
import Button from "src/Components/Button";
import FullScreenLoading from "src/Components/Loading/FullScreenLoading";
import { WrappedTimeSeriesChart } from "src/Components/Timeseries/WrappedTimeSeriesChart";
// Requests
import { getAnnualizedMwrReturnGraph } from "src/Requests/imePortfolio";
// Utilities
import { packetErrorHandler } from "src/Utils/requestUtils";
// Types
import { Graph_Dto } from "src/Interfaces/orderbookGraphInterfaces";
import {
  IInvestmentReturnTableReport,
  IMwrPeriodReturnGraph,
} from "src/Interfaces/imePortfolio";

interface IProps {
  row: IInvestmentReturnTableReport;
}

const MwrAnnualChart = ({ row }: IProps) => {
  // local store
  const [loading, setLoading] = React.useState(false);
  const [graphData, setGraphData] = React.useState<Graph_Dto[]>([]);
  const [from, setFromDate] = React.useState(
    getDateFromToday(90).toISOString(),
  );
  const [to, setToDate] = React.useState(new Date().toISOString());

  React.useEffect(() => {
    setLoading(true);
    const data: IMwrPeriodReturnGraph = {
      from,
      to,
      userId: row.userId,
    };
    getAnnualizedMwrReturnGraph(data)
      .then((resp: Graph_Dto[]) => setGraphData(resp))
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  }, [row]);

  function getDateFromToday(dayCount: number) {
    const targetDate = new Date();
    targetDate.setDate(new Date().getDate() - dayCount);
    return targetDate;
  }
  const handleFromDate = (_: string, value: any) => {
    setFromDate(value);
  };

  const handleToDate = (_: string, value: any) => {
    setToDate(value);
  };

  const onSubmit = () => {
    setLoading(true);
    const data: IMwrPeriodReturnGraph = {
      from,
      to,
      userId: row.userId,
    };
    getAnnualizedMwrReturnGraph(data)
      .then((resp: Graph_Dto[]) => setGraphData(resp))
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  const setDateFromBtns = (dayCount: number) => {
    const today = new Date();
    const targetDate = getDateFromToday(dayCount);
    setFromDate(targetDate.toISOString());
    setToDate(today.toISOString());
  };

  const getDateSetterBtn = (dayCount: number) => (
    <Button
      text={`${dayCount} روز`}
      onClick={() => setDateFromBtns(dayCount)}
      variant={
        from?.split("T")[0] ===
        getDateFromToday(dayCount).toISOString()?.split("T")[0]
          ? "contained"
          : "outlined"
      }
    />
  );

  return (
    <div className="h-full w-full min-h-0 flex flex-row items-stretch gap-5 px-4">
      {loading ? <FullScreenLoading /> : <></>}
      <div className="flex shrink-0 flex-col justify-start items-start gap-3">
        <DatePicker
          label="از تاریخ"
          name="from"
          onChange={handleFromDate}
          value={from}
        />
        <DatePicker
          label="تا تاریخ"
          name="to"
          onChange={handleToDate}
          value={to}
        />
        <div className="flex flex-row justify-start items-center gap-1 w-full">
          {getDateSetterBtn(7)}
          {getDateSetterBtn(30)}
          {getDateSetterBtn(90)}
        </div>
        <Button text="جستجو" onClick={onSubmit} variant="contained" />
      </div>
      <div className="chart-fill-modal font-bold">
        <WrappedTimeSeriesChart dataset={graphData} withDate className="h-full w-full" />
      </div>
    </div>
  );
};

export default MwrAnnualChart;
